var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57888 6.8554e-08C4.59709 -0.000261132 3.77193 0.745915 3.66253 1.73291L0.0218534 34.8981C-0.215061 37.0551 1.50589 39 3.65124 39H38.3488C40.4941 39 42.2151 37.0551 41.9781 34.8981L38.3375 1.73291C38.2281 0.745915 37.4029 -0.000261114 36.4211 6.8554e-08H5.57888ZM13.2894 3.72861C14.8863 3.72861 16.1809 5.03818 16.1809 6.65361C16.1809 7.30629 15.9657 7.90501 15.6067 8.38968C15.4155 8.6478 15.2171 9.08262 15.2171 9.4057V13.65C15.2171 16.9246 17.7629 19.5 21 19.5C24.2371 19.5 26.7829 16.9246 26.7829 13.65V9.4057C26.7829 9.08262 26.5845 8.64779 26.3933 8.38966C26.0342 7.905 25.8191 7.30628 25.8191 6.65361C25.8191 5.03818 27.1137 3.72861 28.7106 3.72861C30.3075 3.72861 31.602 5.03818 31.602 6.65361C31.602 7.30629 31.3869 7.90501 31.0278 8.38968C30.8366 8.6478 30.6382 9.08262 30.6382 9.4057V13.65C30.6382 19.0178 26.3062 23.4 21 23.4C15.6938 23.4 11.3618 19.0178 11.3618 13.65V9.4057C11.3618 9.08262 11.1634 8.64779 10.9722 8.38966C10.6131 7.905 10.398 7.30628 10.398 6.65361C10.398 5.03818 11.6925 3.72861 13.2894 3.72861Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralShopping);
export default __webpack_public_path__ + "static/media/general-shopping.593a8e8dada4ece345ab7fb6f4f66e7c.svg";
export { ForwardRef as ReactComponent };